import { ReactComponent as IndeedIcon } from './indeed.svg';
import { variants } from '../variants';

import { Props } from '../Icons.types';

export const Indeed = ({ variant = 'primary', ...props }: Props) => <IndeedIcon fill={variants[variant]} {...props} />;
